export default "__VITE_ASSET__BxUqzVOF__"